import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import Amplify from "aws-amplify";
import config from "./config";

function debounce(func, delay) {
  let timeout;
  return function () {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, arguments), delay);
  };
}

Amplify.configure({
  Auth: {
    mandatorySignIn: true,
    region: config.cognito.REGION,
    userPoolId: config.cognito.USER_POOL_ID,
    userPoolWebClientId: config.cognito.APP_CLIENT_ID,
  },
  API: {
    endpoints: [
      {
        name: "notes",
        endPoint: "",
        region: config.cognito.REGION,
      },
    ],
  },
});

const Index = () => {
  const [isLargeScreen, setIsLargeScreen] = useState(window.innerWidth >= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsLargeScreen(window.innerWidth >= 768);
    };

    const debouncedHandleResize = debounce(handleResize, 200);

    window.addEventListener("resize", debouncedHandleResize);
    return () => {
      window.removeEventListener("resize", debouncedHandleResize);
    };
  }, []);

  return <> <App /></>;
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<Index />);

reportWebVitals();

// const MobileViewRestriction = () => (
//   <div className="flex flex-col justify-center items-center w-full min-h-screen bg-gray-50 px-4">
//     {/* Mobile Frame Wrapper */}
//     <div className="bg-white w-full max-w-xs sm:max-w-sm rounded-xl shadow-lg border border-gray-200 overflow-hidden">
//       {/* Header Section */}
//       <section className="flex flex-col w-full bg-blue-52 justify-center items-center py-6">
//         <img className="w-48 h-16" src="logo/NEWLOGO.png" alt="Yvooa logo" />
//         <span className="text-white text-lg sm:text-xl text-center mt-2">
//           <p>Your Residential Solutions;</p>
//           <p>under one roof.</p>
//         </span>
//       </section>

//       {/* Content Section */}
//       <div className="flex flex-col items-center px-6 py-8">
//         <h1 className="text-2xl font-bold mt-4 mb-2 text-center text-gray-800">
//           Oops!
//         </h1>
//         <p className="text-base text-center text-gray-600 leading-relaxed">
//           This website is designed for larger screens. Please use a device with
//           a wider screen for the best experience.
//         </p>
//       </div>
//     </div>
//   </div>
// );
